import { DefaultTheme } from 'styled-components';

export const theme: DefaultTheme = {
  fonts: {
    bold: 'Montserrat bold',
    regular: 'Montserrat regular'
  },
  colors: {
    red: '#BC103E',
    green: '#0DBA99',
    white: '#FFFFFF',
    black: '#000000',
    darkGrey: '#202124',
    lightGrey: '#EBEDED',
    grey: '#A6ADB4',
    backgroundGrey: '#29528286',
    redWriting: '#C10230',
    blueWriting: '#009ED3'
  }
};
